import React from 'react';
import PropTypes from 'prop-types';
import Select from '../select';
import Countries from './countries.js';

export default class CountrySelect extends React.Component {
  static displayName = 'CountrySelect';
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    value: null,
    disabled: false,
  };

  countriesWithPlaceholder() {
    return [{ value: '', text: this.props.placeholder }].concat(Countries);
  }

  render() {
    const countries = this.props.placeholder
      ? this.countriesWithPlaceholder()
      : Countries;

    return (
      <Select
        options={countries}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        value={this.props.value}
      />
    );
  }
}
